/*
  tns-kein-inspizieren — Rechtsklick, Entwicklertasten und Textauswahl sperren.

  WARUM ES DAS GIBT: Shrine führt die Einstellung `disable_inspect`, in allen
  sechs Shops auf true. Nick hat am 01.10.2026 per Pop-up entschieden:
  „Nachbauen, wie live". Meine Empfehlung war, es zu lassen — die Sperre hält
  niemanden auf, der kopieren will, kostet aber echte Kunden Bequemlichkeit.
  Die Entscheidung ist seine, hier steht sie als Code.

  WAS LIVE GEMESSEN WURDE (elynor.store, 01.10.2026, Events dispatcht und
  geprüft, ob preventDefault greift):
    Kontextmenü      gesperrt
    F12              gesperrt
    Strg+Shift+I/J/C gesperrt
    Strg+U           gesperrt
    Strg+S           NICHT gesperrt
    selectstart      gesperrt
    dragstart, copy  NICHT gesperrt

  EIN UNTERSCHIED ZUM ORIGINAL, ABSICHTLICH: in Eingabefeldern bleibt die
  Textauswahl erlaubt. Live ist sie global gesperrt — damit kann ein Kunde in
  einem Adress- oder Gutscheinfeld nichts markieren und nichts korrigieren.
  Das ist kein Schutz, das ist ein Fehler, und er kostet Bestellungen.
*/
(function () {
  var AUS = ['INPUT', 'TEXTAREA', 'SELECT', 'OPTION'];

  function inEingabefeld(ziel) {
    if (!ziel || !ziel.nodeName) return false;
    if (AUS.indexOf(ziel.nodeName) !== -1) return true;
    return !!(ziel.closest && ziel.closest('input, textarea, select, [contenteditable="true"]'));
  }

  document.addEventListener('contextmenu', function (e) {
    if (inEingabefeld(e.target)) return;
    e.preventDefault();
  });

  document.addEventListener('selectstart', function (e) {
    if (inEingabefeld(e.target)) return;
    e.preventDefault();
  });

  document.addEventListener('keydown', function (e) {
    var t = e.key || '';
    var gesperrt =
      t === 'F12' ||
      (e.ctrlKey && e.shiftKey && (t === 'I' || t === 'i' || t === 'J' || t === 'j' || t === 'C' || t === 'c')) ||
      (e.metaKey && e.altKey && (t === 'I' || t === 'i' || t === 'J' || t === 'j' || t === 'C' || t === 'c')) ||
      (e.ctrlKey && !e.shiftKey && (t === 'U' || t === 'u'));
    if (!gesperrt) return;
    if (inEingabefeld(e.target)) return;
    e.preventDefault();
  });
})();
